<template>
    <TxRendererScreenshotArea>
        <love-map/>
        <love-map-title/>
    </TxRendererScreenshotArea>
</template>

<script>
    import LoveMap from './LoveMap'
    import LoveMapTitle from './LoveMapTitle'
    import LovemapModule from "../store-mixin";

    export default {
        name: 'LoveMapProduct',
        mixins: [LovemapModule()],
        components: {
            LoveMap,
            LoveMapTitle,
        },
    }
</script>

<style lang="scss">
    @font-face {
        font-family: 'Bodoni-72';
        src: url('../assets/fonts/Bodoni-72-Book.eot');
        src: url('../assets/fonts/Bodoni-72-Book.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/Bodoni-72-Book.woff2') format('woff2'),
        url('../assets/fonts/Bodoni-72-Book.woff') format('woff'),
        url('../assets/fonts/Bodoni-72-Book.ttf') format('truetype'),
        url('../assets/fonts/Bodoni-72-Book.svg#Bodoni-72-Book') format('svg');
    }

    @font-face {
        font-family: 'Quicksand Book';
        src: url('../assets/fonts/QuicksandBook-Regular.eot');
        src: url('../assets/fonts/QuicksandBook-Regular.eot?#iefix') format('embedded-opentype'),
        url('../assets/fonts/QuicksandBook-Regular.woff2') format('woff2'),
        url('../assets/fonts/QuicksandBook-Regular.woff') format('woff'),
        url('../assets/fonts/QuicksandBook-Regular.ttf') format('truetype'),
        url('../assets/fonts/QuicksandBook-Regular.svg#QuicksandBook-Regular') format('svg');
    }
</style>

<style scoped lang="scss">
    .love-map-container {

    }
</style>

